export default {
  path: "/main/story/list",
  name: "List",
  component: () => import("@/views/main/Story/list.vue"),
  children: []
};
